import React, { useContext, useState } from "react";

import { Button, Typography } from "@mui/material";

import { startModuleTrial } from "api/endpoints/subscription";
import { callOptionsHeaders } from "api/helpers";
import ConfirmDialog from "components/shared/confirm-dialog";
import { MODULE_ACTION_BUTTON_MIN_WIDTH } from "constants/index";
import { GrpcError, SnackbarContext } from "context/snackbar-context";

interface StartModuleTrialProps {
  orgId: string;
  regionCode: string;
  moduleName: string;
  moduleLabel: string;
  onSuccess: () => void;
}

const StartModuleTrial = ({
  orgId,
  regionCode,
  moduleName,
  moduleLabel,
  onSuccess,
}: StartModuleTrialProps) => {
  const { showError } = useContext(SnackbarContext);
  const [openDialog, setOpenDialog] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const handleConfirm = async () => {
    setIsSaving(true);
    try {
      await startModuleTrial(
        { orgId, moduleName },
        callOptionsHeaders(regionCode, orgId),
      );
      setOpenDialog(false);
      onSuccess();
    } catch (err) {
      showError(err as GrpcError);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <>
      <Button
        sx={{ mt: 1, mr: 2, minWidth: MODULE_ACTION_BUTTON_MIN_WIDTH }}
        data-testid={`${moduleName}-start-trial`}
        variant="contained"
        color="primary"
        onClick={() => setOpenDialog(true)}
      >
        START TRIAL
      </Button>

      <ConfirmDialog
        title="Start Module Trial"
        cancelBtnLabel="CANCEL"
        confirmBtnLabel="START TRIAL"
        open={openDialog}
        setOpen={setOpenDialog}
        disabled={isSaving}
        disableCancelBtn={isSaving}
        disableCloseOnConfirm
        onConfirm={handleConfirm}
        onCancel={() => setOpenDialog(false)}
      >
        <Typography data-testid={`${moduleName}-start-trial-form`}>
          Start a {moduleLabel} trial for this organization?
        </Typography>
      </ConfirmDialog>
    </>
  );
};

export default StartModuleTrial;
